<template>
  <b-row class="mt-3">
    <b-col cols="12">
      <b-tabs content-class="mt-0">
        <template v-for="(tab, index) in widgetData.tabs">
          <b-tab :title="getTitle(tab.title)" :key="index">
            <widget-inner :widget-data="tab.widget" ref="childWidgets"/>
          </b-tab>
        </template>
      </b-tabs>
    </b-col>
  </b-row>
</template>

<script>

  import {mapState} from "vuex";

export default {
  name: 'TabsWidget',

    components: {
        'widget-inner': () => import('./Widget.vue')
    },

  data() {
    return {}
  },

  props: {
    widgetData: Object
  },

  computed: {
    ...mapState(['nodeInfo']),
  },

  methods: {
    getTitle(titleMap) {
      return this.$tmap(titleMap)
    },

    requestData(requester) {
      for(const cw of this.$refs.childWidgets) {
        cw.requestData(requester);
      }
    },
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*  .column {*/
/*    !*background-color: #dddddd;*!*/
/*}*/
/*  .dynrow {*/
/*    !*margin-top: 1em;*!*/
/*  }*/

  /*.headerRow {*/
  /*    margin-top: 1em;*/
  /*    background-color: white;*/
  /*    border: 1px #dddddd solid;*/
  /*}*/

  /*.nodeTitle {*/
  /*  margin-left: 8px;*/
  /*  font-size: 150%;*/
  /*}*/

</style>
